import React from "react";

type UseYtdDataProps = {
  isLoading: boolean;
  availableYears: number[] | undefined;
  selectedYear: number;
  setSelectedYear: (year: number) => void;
};

export const useYtdData = (props: UseYtdDataProps) => {
  const { availableYears = [], isLoading, selectedYear, setSelectedYear } = props;

  React.useEffect(() => {
    if (!availableYears || availableYears.length === 0) {
      return;
    }
    if (!availableYears.includes(selectedYear)) {
      const mostRecentYear = Math.max(...availableYears);
      setSelectedYear(mostRecentYear);
    }
  }, [availableYears, selectedYear, setSelectedYear]);

  const yearOptions = availableYears.map((year) => ({
    value: year.toString(),
    label: year.toString(),
  }));
  const handleYearChange = React.useCallback(
    (value: string | null) => {
      if (!value) {
        return;
      }
      const year = Number(value);
      if (Number.isNaN(year)) {
        return;
      }
      setSelectedYear(year);
    },
    [setSelectedYear]
  );

  return {
    selectProps: {
      disabled: isLoading || yearOptions.length < 1,
      placeholder: "Year",
      data: yearOptions,
      value: selectedYear.toString(),
      onChange: handleYearChange,
    },
  };
};
